import { AccountInfo } from "@azure/msal-browser";

export class TenantSyncMessage {
    public tenant: string;
    public user?: AccountInfo;

    constructor(tenant: string, user?: AccountInfo) {
        this.tenant = tenant;
        this.user = user;
    }
}